<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Grupos</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Grupos</small></h1>

@if(!group && !showEditGroup){
<div class="scrollable">
    <panel [noButton]="true">

        <div class="d-flex justify-content-between align-items-center mb-4">
            <input type="text" class="form-control form-control-sm w-75"
                (keyup.enter)="filtrarGrupos($event.target.value)" placeholder="Buscar por nombre...">
            <button class="btn btn-success btn-xs" (click)="addGroup()"> <i class="fas fa-plus me-1"></i> Nuevo</button>
        </div>

        @if(groups?.length > 0){
        <div class="card-list">
            @for(group of groups; track group.id; let i = $index){
            <div class="card-item" [class.item-disabled]="!group.enabled">
                <div class="card-row">
                    <div class="card-info">
                        <span class="card-badge">{{ group.acronym }}</span>
                        <span class="card-title">{{ group.name }}</span>
                    </div>

                    <div class="card-actions">
                        <button class="btn btn-xs btn-ghost" (click)="moveUp(i)" [disabled]="i === 0"
                            ngbTooltip="Subir">
                            <i class="fas fa-chevron-up"></i>
                        </button>
                        <button class="btn btn-xs btn-ghost" (click)="moveDown(i)" [disabled]="i === groups.length - 1"
                            ngbTooltip="Bajar">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        @if (group.enabled) {
                        <i class="fas fa-check-circle status-icon enabled" (click)="toggleGroup(group)"
                            ngbTooltip="Habilitado — click para deshabilitar"></i>
                        } @else {
                        <i class="fas fa-times-circle status-icon disabled" (click)="toggleGroup(group)"
                            ngbTooltip="Deshabilitado — click para habilitar"></i>
                        }
                        <button class="btn btn-xs btn-ghost text-primary" (click)="setEditGroup(group)" ngbTooltip="Editar">
                            <i class="fas fa-edit"></i>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <div class="text-center py-5 text-muted">
            <i class="fas fa-folder-open fs-1 mb-3 d-block"></i>
            <span>No hay registros para mostrar.</span>
        </div>
        }

    </panel>
</div>
}@else{
<ng-container>
    <app-edit-group [group]="group" (close)="showEditGroup = false; group = null"
        (update)="getGroups()"></app-edit-group>
</ng-container>
}
